export const API_BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://securechat-api.alextesting.ninja"
    : "http://localhost:8000";
